module.exports = __webpack_public_path__ + "assets/preemLarge.84d537f4.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/logos/preemLarge.png
// module id = 274
// module chunks = 1